import { useMutation } from 'react-query'

// Services
import { ListIntegrationToken } from 'services/api/Auth'

export default () => {
  const {
    mutate: listIntegrationToken,
    data: listIntegrationTokenData,
    error: listIntegrationTokenError,
    isLoading: isListIntegrationTokenLoading,
    isSuccess: isListIntegrationTokenSuccess,
    isError: isListIntegrationTokenError,
  } = useMutation(ListIntegrationToken)

  // credentials and isloggedin are set in the loginform component

  return {
    listIntegrationToken,
    listIntegrationTokenData,
    listIntegrationTokenError,
    isListIntegrationTokenLoading,
    isListIntegrationTokenSuccess,
    isListIntegrationTokenError,
  }
}
